/// <amd-module name="VSSUI/Components/IdentityCard/DefaultCard" />

import * as React from "react";
import * as Resources from "VSSUI/Resources.Persona";

import { Button } from "VSSUI/Button";
import { CardContactLine } from "./CardContactLine";
import { IDefaultCardProps } from "./ContactCard.Props";
import { Icon } from "VSSUI/Icon";
import { Persona } from "../Persona/Persona";
import { PersonaSize } from "../Persona/Persona.Props";
import { css } from "VSSUI/Util";

export class DefaultCard extends React.Component<IDefaultCardProps> {
    private contactButtonRef = React.createRef<Button>();
    // Setting the focus for the case of default card mounting when we come back via back header
    public componentDidMount(): void {
        if (this.contactButtonRef.current) {
            this.contactButtonRef.current.focus();
        }
    }

    // Render
    public render(): JSX.Element {
        const { identity, isPreviousHeader } = this.props;
        const { displayName, department, jobTitle, mail, physicalDeliveryOfficeName, telephoneNumber } = identity;

        return (
            <div
                className={css(
                    "bolt-identity-card-content flex-column scroll-hidden",
                    isPreviousHeader ? "bolt-identity-default-card-with-header" : "bolt-identity-default-card-without-header"
                )}
            >
                <div className="flex-row">
                    <Persona className="bolt-identity-card-persona-main" size={PersonaSize.size72} identity={this.props.identity} />
                    <div className="flex-column flex-grow bolt-identity-card-name scroll-hidden">
                        <div className="word-wrap title-s">{displayName}</div>
                        {jobTitle === "" ? undefined : <div className="text-ellipsis">{jobTitle}</div>}
                        {department === "" ? undefined : <div className="text-ellipsis">{department}</div>}
                    </div>
                </div>
                <div className="flex-column scroll-hidden">
                    {(mail || telephoneNumber || physicalDeliveryOfficeName) && (
                        <div className="bolt-identity-default-card-info-wrapper ">
                            <hr className="bolt-identity-card-hr" />
                            <div className="bolt-identity-default-card-header-wrapper">
                                <Button
                                    aria-label={Resources.IdentityCardContact}
                                    className="bolt-identity-default-card-header pointer bolt-profile-card-tab-element"
                                    onClick={() => {
                                        this.props.showContactCard();
                                    }}
                                    ref={this.contactButtonRef}
                                    role="button"
                                    subtle={true}
                                    text={Resources.IdentityCardContact}
                                >
                                    <Icon iconName={"ChevronRight"} />
                                </Button>
                            </div>

                            <div className="bolt-identity-default-card-contact-info-container flex-column scroll-hidden">
                                {mail && <CardContactLine iconName="Mail" hiddenLabel={Resources.IdentityCardEmail} content={mail} link={`mailto:${mail}`} />}
                                {mail && <CardContactLine iconName="Chat" content={Resources.IdentityCardStartChat} link={`sip:${mail}`} />}
                                {telephoneNumber && <CardContactLine iconName="Phone" hiddenLabel={Resources.IdentityCardPhoneNumber} content={telephoneNumber} link={`tel:${telephoneNumber}`} />}
                                {physicalDeliveryOfficeName && <CardContactLine iconName="POI" hiddenLabel={Resources.IdentityCardLocation} content={physicalDeliveryOfficeName} />}
                            </div>
                        </div>
                    )}

                    {this.renderDirectManagerElement()}
                </div>
            </div>
        );
    }

    /**
     * Renders the direct manager for the persona.
     * @param managerIdentity The manager persona.
     */
    private renderDirectManagerElement() {
        if (!this.props.manager) {
            return <div />;
        }
        const adjacentManager = this.props.manager;
        const adjacentManagerData = {
            imageUrl: adjacentManager.image,
            primaryText: adjacentManager.displayName,
            secondaryText: adjacentManager.jobTitle,
            tertiaryText: adjacentManager.department
        };

        return (
            <div className="bolt-identity-default-card-direct-manager-wrapper">
                <hr className="bolt-identity-card-hr" />

                <div className="bolt-identity-default-card-header-wrapper">
                    <Button
                        aria-label={Resources.IdentityCardOrganization}
                        className="bolt-identity-default-card-header pointer bolt-profile-card-tab-element"
                        onClick={() => {
                            this.props.showOrganizationCard && this.props.showOrganizationCard();
                        }}
                        role="button"
                        text={Resources.IdentityCardOrganization}
                        subtle={true}
                    >
                        <Icon iconName={"ChevronRight"} />
                    </Button>
                </div>

                <div className="bolt-identity-default-card-direct-manager">
                    <div className="bolt-identity-default-card-header-reportsto">{Resources.IdentityCardReportsTo}</div>
                    <div className="flex-row scroll-hidden bolt-identity-card-reports-to-wrapper">
                        <Button
                            className="bolt-identity-card-persona-list-element bolt-profile-card-tab-element flex-shrink text-ellipsis"
                            aria-label={adjacentManager.displayName}
                            key={adjacentManager.entityId + adjacentManager.signInAddress}
                            onClick={() => {
                                this.props.onClickEntity && this.props.onClickEntity(adjacentManager);
                            }}
                            subtle={true}
                        >
                            <Persona size={PersonaSize.size40} identity={adjacentManager} />
                            <div className="bolt-identity-card-text flex-column scroll-hidden">
                                <div className="primary-text flex-row text-ellipsis">{adjacentManagerData.primaryText}</div>
                                {adjacentManagerData.secondaryText === "" ? (
                                    undefined
                                ) : (
                                    <div className="secondary-text flex-row text-ellipsis">{adjacentManagerData.secondaryText}</div>
                                )}
                            </div>
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
}
